<app-field-container [field]="this">
  <select [formControl]="control" class="form-select">
    @for (choice of choices(); track choice) {
      <option [ngValue]="choice.value">{{ choice.text }}</option>
    }
  </select>
</app-field-container>
